import { useState } from "react";
import { Marker,  } from "@react-google-maps/api";
import SLogo from "../../../../assets/Images/Header/YellowSLogo.svg"
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleSetIsShowAdvertPreview } from "apps/RealState/ListItems/ClientStates";
import { handleSetSelectedMarkerData, handleSetShowMarkerTooltip } from "../ClientStates";
import { RootState } from "store/Reducers";
import InfoWindowItem from "./InfoWindowItem";
import MarkerTooltip from "./MarkerTooltip";

const MarkerItem = (props: any) => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const {isShowMarkerTooltip} = useSelector((state:RootState)=>state.mapList)

  // console.log("is show",isShowMarkerTooltip)
  // console.log("marker item props", props.item?.latitude);
 

  
  return (
    <>
      <Marker
        onClick={async () => {
          await setSearchParams({ id: props.item.id });
          dispatch(handleSetIsShowAdvertPreview({ status: true }));
        }}
        position={{
          lat: Number(props.item?.latitude),
          lng: Number(props.item?.longitude),
        }}
        icon={{
          url: SLogo,
          scaledSize: new google.maps.Size(20, 20),
          anchor: new google.maps.Point(15, 15),
        }}
        onMouseOver={async() => {
            await dispatch(handleSetSelectedMarkerData({data:props.item}))
            dispatch(  handleSetShowMarkerTooltip({status:true}))
        }}
        
      
      />

     
        <MarkerTooltip/>
    </>
  );
};

export default MarkerItem;


